module.exports = "/assets/data/729b63ed9641dcbf18c1bf3b34da5a5c-LS20.data.json";